/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../enigma/service';
import '../../common/entry_method';
import '../../bills/tender';
import '../../bills/client_details';
import '../../common/emv';
import '../../common/currency';
import '../../fees/models';
import '../../common/location';
import '../../common/payment';
import './endpoint_info';
import '../../bills/creator_details';
import '../../common/currency_codes';
import './common';
import '../../common/fee';
import '../../pago/external/payments_api';
import '../../common/number';
import '../../../google/protobuf/empty';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "common": {
            "nested": {
              "ClientMetadata": {
                "fields": {
                  "readerInfo": {
                    "type": ".squareup.enigma.service.ReaderInfo",
                    "id": 1,
                    "rule": "optional"
                  },
                  "squareWallet": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "checkId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "entryMethod": {
                    "type": ".squareup.common.PayWithSquareEntryMethod",
                    "id": 6,
                    "rule": "optional"
                  },
                  "payerToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "clientStoreAndForwardCreatedAtMs": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "chipCardFallbackIndicator": {
                    "type": ".squareup.bills.CardTender.Card.ChipCardFallbackIndicator",
                    "id": 9,
                    "rule": "optional"
                  },
                  "payerIp": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "developerIp": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "appId": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "connectDetails": {
                    "type": ".squareup.bills.ClientDetails.ConnectDetails",
                    "id": 13,
                    "rule": "optional"
                  },
                  "invoiceDetails": {
                    "type": ".squareup.bills.ClientDetails.InvoiceDetails",
                    "id": 14,
                    "rule": "optional"
                  },
                  "isEmvCapableReaderPresent": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  },
                  "loggableSessionToken": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "tenderPricingMetadata": {
                    "type": ".squareup.bills.Tender.TenderPricingMetadata",
                    "id": 17,
                    "rule": "optional"
                  },
                  "emvCaptureTags": {
                    "type": ".squareup.common.EmvTags",
                    "id": 18,
                    "rule": "optional"
                  },
                  "vendorReaderInfo": {
                    "type": ".squareup.esperanto.common.ClientMetadata.VendorReaderInfo",
                    "id": 19,
                    "rule": "optional"
                  },
                  "terminalData": {
                    "type": ".squareup.esperanto.common.TerminalData",
                    "id": 20,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "VendorReaderInfo": {
                    "fields": {
                      "vendorReaderId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "vendorReaderTransactionId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SettlementMetadata": {
                "fields": {
                  "processingDateMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessDateMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "clientPaymentId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PerformedExperimentMetadata": {
                "fields": {
                  "performedExperiment": {
                    "type": ".squareup.esperanto.common.PerformedExperimentMetadata.PerformedExperiment",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "PerformedExperiment": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "bucketName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "banditId": {
                        "type": "int64",
                        "id": 3,
                        "rule": "optional"
                      },
                      "bucketId": {
                        "type": "int64",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "PaymentMetadata": {
                "fields": {
                  "appPlatformAccount": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "appFee": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "refundAppFee": {
                    "type": ".squareup.esperanto.common.RefundAppFee",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "appFeeUnitToken": {
                    "type": "string",
                    "id": 33,
                    "rule": "optional"
                  },
                  "paymentFeesSpec": {
                    "type": ".squareup.fees.PaymentFeesSpec",
                    "id": 19,
                    "rule": "optional"
                  },
                  "refundFeesSpec": {
                    "type": ".squareup.fees.RefundPaymentFeesSpec",
                    "id": 20,
                    "rule": "repeated"
                  },
                  "connectDetails": {
                    "type": ".squareup.bills.ClientDetails.ConnectDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "geolocatedTransactionAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 49,
                    "rule": "optional"
                  },
                  "peripheralMetadata": {
                    "type": ".squareup.common.payment.PeripheralMetadata",
                    "id": 11,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "squareProductReferenceIds": {
                    "type": "string",
                    "id": 44,
                    "keyType": "string"
                  },
                  "originatingService": {
                    "type": ".squareup.common.payment.OriginatingService",
                    "id": 7,
                    "rule": "optional"
                  },
                  "entryMethod": {
                    "type": ".squareup.common.PayWithSquareEntryMethod",
                    "id": 8,
                    "rule": "optional"
                  },
                  "checkoutId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "orderInfo": {
                    "type": ".squareup.esperanto.common.OrderInfo",
                    "id": 14,
                    "rule": "optional"
                  },
                  "createPaymentNote": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "customerIdUpdatedAtMs": {
                    "type": "int64",
                    "id": 43,
                    "rule": "optional"
                  },
                  "buyerId": {
                    "type": "string",
                    "id": 36,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": ".squareup.common.Money",
                    "id": 17,
                    "rule": "optional"
                  },
                  "taxMoney": {
                    "type": ".squareup.common.Money",
                    "id": 18,
                    "rule": "optional"
                  },
                  "updatedPaymentData": {
                    "type": ".squareup.esperanto.common.UpdatedPaymentData",
                    "id": 21,
                    "rule": "optional"
                  },
                  "gatewayAllowsEdits": {
                    "type": "bool",
                    "id": 22,
                    "rule": "optional"
                  },
                  "delayedActionDetails": {
                    "type": ".squareup.esperanto.common.DelayedActionDetails",
                    "id": 23,
                    "rule": "optional"
                  },
                  "payInMetadata": {
                    "type": ".squareup.esperanto.common.PayInMetadata",
                    "id": 24,
                    "rule": "optional"
                  },
                  "billpayPullMetadata": {
                    "type": ".squareup.esperanto.common.BillPayPullMetadata",
                    "id": 42,
                    "rule": "optional"
                  },
                  "superPosMetadata": {
                    "type": ".squareup.esperanto.common.SuperPosMetadata",
                    "id": 51,
                    "rule": "optional"
                  },
                  "cardSurchargeMetadata": {
                    "type": ".squareup.esperanto.common.CardSurchargeMetadata",
                    "id": 53,
                    "rule": "optional"
                  },
                  "buyerInfo": {
                    "type": ".squareup.esperanto.common.BuyerInfo",
                    "id": 25,
                    "rule": "optional"
                  },
                  "customerInitiated": {
                    "type": "bool",
                    "id": 28,
                    "rule": "optional"
                  },
                  "clientStoreAndForwardCreatedAtMs": {
                    "type": "int64",
                    "id": 50,
                    "rule": "optional"
                  },
                  "sourceInstrumentType": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "refundPolicy": {
                    "type": ".squareup.esperanto.common.RefundPolicy",
                    "id": 27,
                    "rule": "optional"
                  },
                  "clientEndpointInfo": {
                    "type": ".squareup.esperanto.common.EndpointInfo",
                    "id": 29,
                    "rule": "optional"
                  },
                  "creatorDetails": {
                    "type": ".squareup.bills.CreatorDetails",
                    "id": 30,
                    "rule": "optional"
                  },
                  "tenderPricingMetadata": {
                    "type": ".squareup.bills.Tender.TenderPricingMetadata",
                    "id": 32,
                    "rule": "optional"
                  },
                  "allowedPaymentCapabilities": {
                    "type": ".squareup.esperanto.common.PaymentMetadata.PaymentCapability",
                    "id": 31,
                    "rule": "repeated"
                  },
                  "disabledPaymentCapabilities": {
                    "type": ".squareup.esperanto.common.PaymentMetadata.PaymentCapability",
                    "id": 41,
                    "rule": "repeated"
                  },
                  "sellerKeyedIn": {
                    "type": "bool",
                    "id": 34,
                    "rule": "optional"
                  },
                  "incrementalAuthEligible": {
                    "type": "bool",
                    "id": 35,
                    "rule": "optional"
                  },
                  "buyerToMerchantExchange": {
                    "type": ".squareup.esperanto.common.ForeignExchange",
                    "id": 37,
                    "rule": "optional"
                  },
                  "buyerCurrencyExchange": {
                    "type": ".squareup.esperanto.common.CurrencyExchange",
                    "id": 54,
                    "rule": "optional"
                  },
                  "merchantSettlementCurrency": {
                    "type": ".squareup.common.CurrencyCode",
                    "id": 38,
                    "rule": "optional"
                  },
                  "giftCardRefundPushmoneyPaymentIds": {
                    "type": "string",
                    "id": 45,
                    "rule": "repeated"
                  },
                  "proposalId": {
                    "type": "string",
                    "id": 46,
                    "rule": "optional"
                  },
                  "healthcareDetails": {
                    "type": ".squareup.esperanto.common.HealthcareDetails",
                    "id": 47,
                    "rule": "optional"
                  },
                  "isTestPayment": {
                    "type": "bool",
                    "id": 48,
                    "rule": "optional"
                  },
                  "routeConfigId": {
                    "type": "string",
                    "id": 52,
                    "rule": "optional"
                  },
                  "appFeeAllocations": {
                    "type": ".squareup.esperanto.common.AppFeeAllocation",
                    "id": 55,
                    "rule": "repeated"
                  },
                  "refundedAppFeeAllocations": {
                    "type": ".squareup.esperanto.common.RefundedAppFeeAllocation",
                    "id": 56,
                    "rule": "repeated"
                  },
                  "offlinePaymentMetadata": {
                    "type": ".squareup.esperanto.common.OfflinePaymentMetadata",
                    "id": 57,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PaymentCapability": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "NO_CAPABILITY": 1,
                      "EDIT_AMOUNT_UP": 2,
                      "EDIT_AMOUNT_DOWN": 3,
                      "EDIT_TIP_AMOUNT_UP": 4,
                      "EDIT_TIP_AMOUNT_DOWN": 5
                    }
                  }
                }
              },
              "UpdatedPaymentData": {
                "fields": {
                  "idempotencyKeys": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "amountMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cashPaymentDetails": {
                    "type": ".squareup.esperanto.common.CashPaymentDetails",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CashPaymentDetails": {
                "fields": {
                  "buyerSuppliedMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "changeBackMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ProcessingFeeEvent": {
                "fields": {
                  "eventId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "effectiveAtMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.esperanto.common.ProcessingFeeEvent.Type",
                    "id": 5,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "feeType": {
                    "type": ".squareup.esperanto.common.ProcessingFeeEvent.FeeType",
                    "id": 7,
                    "rule": "optional"
                  },
                  "pricingMetadata": {
                    "type": ".squareup.esperanto.common.PricingMetadata",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CAPTURE": 1,
                      "CAPTURE_ADJUSTMENT": 2,
                      "REFUND": 3,
                      "REFUND_ADJUSTMENT": 4
                    }
                  },
                  "FeeType": {
                    "values": {
                      "FEE_TYPE_DO_NOT_USE": 0,
                      "SQ_PROCESSING_FEE": 1,
                      "TAX_ON_FEE": 2
                    }
                  }
                }
              },
              "PricingMetadata": {
                "fields": {
                  "pricingType": {
                    "type": ".squareup.esperanto.common.PricingMetadata.PricingType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PricingType": {
                    "values": {
                      "PRICING_TYPE_DO_NOT_USE": 0,
                      "DEFAULT": 1,
                      "BLENDED": 2,
                      "COSTPLUS": 3,
                      "FREE_PROCESSING": 4,
                      "INTERCHANGE_PLUS": 5
                    }
                  }
                }
              },
              "AppFeeEvent": {
                "fields": {
                  "eventId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "effectiveAtMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.esperanto.common.AppFeeEvent.Type",
                    "id": 5,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "priceSelector": {
                    "type": "string",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "party": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "THIRD_PARTY_PAYMENT_FEE": 1,
                      "THIRD_PARTY_REFUND_FEE": 2
                    }
                  }
                }
              },
              "RiskReviewResult": {
                "values": {
                  "DO_NOT_USE": 0,
                  "APPROVED": 1,
                  "REJECTED": 2
                }
              },
              "SynchronousRefundReviewDetails": {
                "fields": {
                  "synchronousRefundReviewResult": {
                    "type": ".squareup.esperanto.common.RiskReviewResult",
                    "id": 1,
                    "rule": "optional"
                  },
                  "balanceBasedRefundReviewDetails": {
                    "type": ".squareup.esperanto.common.SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BalanceBasedRefundReviewDetails": {
                    "fields": {
                      "merchantBalance": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "exposureThreshold": {
                        "type": ".squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "configuration": {
                        "type": ".squareup.esperanto.common.SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails.Configuration",
                        "id": 3,
                        "rule": "optional"
                      },
                      "withinAllowedExposureThreshold": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "decisionSource": {
                        "type": ".squareup.esperanto.common.SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails.DecisionSource",
                        "id": 5,
                        "rule": "optional"
                      },
                      "decision": {
                        "type": ".squareup.esperanto.common.SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails.Decision",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Configuration": {
                        "values": {
                          "DO_NOT_USE_CONFIG": 0,
                          "AFTERPAY_AUD": 1,
                          "AFTERPAY_CAD": 2,
                          "AFTERPAY_USD": 3,
                          "EBT": 4,
                          "EFTPOS": 5,
                          "INTERAC": 6,
                          "SEPA_EUR": 7,
                          "JAPAN": 8
                        }
                      },
                      "Decision": {
                        "values": {
                          "DO_NOT_USE_DECISION": 0,
                          "APPROVED": 1,
                          "REJECTED": 2,
                          "NO_DECISION": 3
                        }
                      },
                      "DecisionSource": {
                        "values": {
                          "DO_NOT_USE_DECISION_SOURCE": 0,
                          "RISK_EVALUATION": 1,
                          "CONFIGURED_THRESHOLD": 2,
                          "HEURISTIC_EVALUATION": 3
                        }
                      }
                    }
                  }
                }
              },
              "RefundMetadata": {
                "fields": {
                  "refundId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientEndpointInfo": {
                    "type": ".squareup.esperanto.common.EndpointInfo",
                    "id": 7,
                    "rule": "optional"
                  },
                  "connectDetails": {
                    "type": ".squareup.bills.ClientDetails.ConnectDetails",
                    "id": 8,
                    "rule": "optional"
                  },
                  "riskReviewResult": {
                    "type": ".squareup.esperanto.common.RiskReviewResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isRefundedAppFeeDerived": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "refundBillId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "suppressEmailNotification": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "riskReviewerId": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "riskReviewComment": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "riskReviewGeneratedDecision": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "merchantToBuyerExchange": {
                    "type": ".squareup.esperanto.common.ForeignExchange",
                    "id": 13,
                    "rule": "optional"
                  },
                  "feeRefundPolicy": {
                    "type": ".squareup.common.RefundPolicy",
                    "id": 14,
                    "rule": "optional"
                  },
                  "isTestUnlinkedRefund": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  },
                  "entryMethod": {
                    "type": ".squareup.common.PayWithSquareEntryMethod",
                    "id": 16,
                    "rule": "optional"
                  },
                  "synchronousRefundReviewDetails": {
                    "type": ".squareup.esperanto.common.SynchronousRefundReviewDetails",
                    "id": 17,
                    "rule": "optional"
                  },
                  "superPosMetadata": {
                    "type": ".squareup.esperanto.common.SuperPosMetadata",
                    "id": 18,
                    "rule": "optional"
                  },
                  "originatingService": {
                    "type": ".squareup.common.payment.OriginatingService",
                    "id": 19,
                    "rule": "optional"
                  }
                }
              },
              "RefundAppFee": {
                "fields": {
                  "refundUuid": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "appFee": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "OrderInfo": {
                "fields": {
                  "orderId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isAutoCreated": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Metadata": {
                "fields": {
                  "clientMetadata": {
                    "type": ".squareup.esperanto.common.ClientMetadata",
                    "id": 1,
                    "rule": "optional"
                  },
                  "settlementMetadata": {
                    "type": ".squareup.esperanto.common.SettlementMetadata",
                    "id": 2,
                    "rule": "optional"
                  },
                  "creatorDetails": {
                    "type": ".squareup.bills.CreatorDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "performedExperimentMetadata": {
                    "type": ".squareup.esperanto.common.PerformedExperimentMetadata",
                    "id": 4,
                    "rule": "optional"
                  },
                  "geolocationType": {
                    "type": ".squareup.esperanto.common.GeoLocationType",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "GeoLocationType": {
                "values": {
                  "GEO_LOCATION_TYPE_DO_NOT_USE": 0,
                  "SQUARE_DEVICE_ACCESS_POINT": 1,
                  "SQUARE_DEVICE_ETHERNET_GEOIP": 2
                }
              },
              "DelayedActionDetails": {
                "fields": {
                  "delayDuration": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "delayAction": {
                    "type": ".squareup.esperanto.common.DelayedActionDetails.DelayAction",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DelayAction": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CANCEL": 1,
                      "COMPLETE": 2
                    }
                  }
                }
              },
              "PayInMetadata": {
                "fields": {
                  "payInUnitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "depositToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "balanceId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "skipWalletReconciliation": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "BillPayPullMetadata": {
                "fields": {
                  "billpayUnitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billpayId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "billpayRecipientDetails": {
                    "type": ".squareup.connect.v2.BillPayRecipientDetails",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "SuperPosMetadata": {
                "fields": {
                  "modeId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CardSurchargeMetadata": {
                "fields": {
                  "cardSurchargeMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "additionalAmountMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "BuyerInfo": {
                "fields": {
                  "email": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "emailSource": {
                    "type": ".squareup.esperanto.common.BuyerInfo.DataSource",
                    "id": 5,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "phoneNumberSource": {
                    "type": ".squareup.esperanto.common.BuyerInfo.DataSource",
                    "id": 6,
                    "rule": "optional"
                  },
                  "ip": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ipSource": {
                    "type": ".squareup.esperanto.common.BuyerInfo.DataSource",
                    "id": 4,
                    "rule": "optional"
                  },
                  "shippingAddressSource": {
                    "type": ".squareup.esperanto.common.BuyerInfo.DataSource",
                    "id": 7,
                    "rule": "optional"
                  },
                  "billingAddressSource": {
                    "type": ".squareup.esperanto.common.BuyerInfo.DataSource",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DataSource": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "EXPLICIT": 1,
                      "NONCE": 2,
                      "VERIFICATION": 3,
                      "CUSTOMER": 4,
                      "ORDER": 5,
                      "REQUEST_METADATA": 6
                    }
                  }
                }
              },
              "RefundPolicy": {
                "fields": {
                  "defaultRefundSplit": {
                    "type": ".squareup.esperanto.common.RefundPolicy.RefundSplitStrategy",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "RefundSplitStrategy": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PROPORTIONAL": 1,
                      "SELLER_ONLY": 2
                    }
                  }
                }
              },
              "ForeignExchange": {
                "fields": {
                  "exchangeProvider": {
                    "type": ".squareup.esperanto.common.ExchangeProvider",
                    "id": 1,
                    "rule": "optional"
                  },
                  "exchangeRate": {
                    "type": ".squareup.common.number.FixedPoint",
                    "id": 2,
                    "rule": "optional"
                  },
                  "exchangeRateRetrievedAtMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "baseMoney": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "convertedMoney": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CurrencyExchange": {
                "fields": {
                  "amountMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "exchangeRate": {
                    "type": ".squareup.common.number.FixedPoint",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ExchangeProvider": {
                "fields": {
                  "providerType": {
                    "type": ".squareup.esperanto.common.ExchangeProvider.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "providerId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CARD_NETWORK": 1,
                      "THIRD_PARTY": 2
                    }
                  }
                }
              },
              "InternalAdminMetadata": {
                "fields": {
                  "forcedRepublishRequestedAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "TerminalData": {
                "fields": {
                  "noTerminal": {
                    "type": ".google.protobuf.Empty",
                    "id": 1
                  },
                  "terminalConfiguration": {
                    "type": ".squareup.esperanto.common.TerminalData.TerminalConfiguration",
                    "id": 2
                  }
                },
                "nested": {
                  "TerminalCapability": {
                    "values": {
                      "DEFAULT_TERMINAL_CAPABILITY_DO_NOT_USE": 0,
                      "PIN_ENTRY": 1,
                      "MANUAL_PAN_ENTRY": 2,
                      "MAGNETIC_STRIPE": 3,
                      "QR_CODE": 4,
                      "EMV_DIP": 5,
                      "EMV_CONTACTLESS": 6,
                      "SUPPORTS_MPOS": 7
                    }
                  },
                  "TerminalConfiguration": {
                    "fields": {
                      "terminalCapabilities": {
                        "type": ".squareup.esperanto.common.TerminalData.TerminalCapability",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "terminalType": {
                        "type": ".squareup.esperanto.common.TerminalData.TerminalConfiguration.TerminalType",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "TerminalType": {
                        "values": {
                          "DEFAULT_TERMINAL_TYPE_DO_NOT_USE": 0,
                          "CONSUMER_DEVICE": 1,
                          "DEDICATED_HARDWARE": 2
                        }
                      }
                    }
                  },
                  "terminal_type": {
                    "oneof": ["noTerminal", "terminalConfiguration"]
                  }
                }
              },
              "OfflinePaymentMetadata": {
                "fields": {
                  "clientCreatedAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "uploadedAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ClientMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ClientMetadata?.nested?.VendorReaderInfo && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.SettlementMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.PerformedExperimentMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.PerformedExperimentMetadata?.nested?.PerformedExperiment && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.PaymentMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.PaymentMetadata?.nested?.PaymentCapability && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.UpdatedPaymentData && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.CashPaymentDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ProcessingFeeEvent && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ProcessingFeeEvent?.nested?.Type && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ProcessingFeeEvent?.nested?.FeeType && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.PricingMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.PricingMetadata?.nested?.PricingType && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AppFeeEvent && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.AppFeeEvent?.nested?.Type && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.RiskReviewResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.SynchronousRefundReviewDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.SynchronousRefundReviewDetails?.nested?.BalanceBasedRefundReviewDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.SynchronousRefundReviewDetails?.nested?.BalanceBasedRefundReviewDetails?.nested?.Configuration && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.SynchronousRefundReviewDetails?.nested?.BalanceBasedRefundReviewDetails?.nested?.Decision && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.SynchronousRefundReviewDetails?.nested?.BalanceBasedRefundReviewDetails?.nested?.DecisionSource && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.RefundMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.RefundAppFee && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.OrderInfo && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.Metadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.GeoLocationType && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.DelayedActionDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.DelayedActionDetails?.nested?.DelayAction && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.PayInMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.BillPayPullMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.SuperPosMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.CardSurchargeMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.BuyerInfo && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.BuyerInfo?.nested?.DataSource && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.RefundPolicy && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.RefundPolicy?.nested?.RefundSplitStrategy && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ForeignExchange && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.CurrencyExchange && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ExchangeProvider && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.ExchangeProvider?.nested?.Type && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.InternalAdminMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.TerminalData && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.TerminalData?.nested?.TerminalCapability && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.TerminalData?.nested?.TerminalConfiguration && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.TerminalData?.nested?.TerminalConfiguration?.nested?.TerminalType && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.OfflinePaymentMetadata) {
  $root.addJSON(jsonData);
}

/**
 * Metadata about the client sending the request.
 *
 * These fields are:
 * 1. Does not influence the semantic of payment API.
 * 2. Are stored in the payments database & forwarded to down stream services.
 *
 * SOURCE ClientMetadata @ squareup/esperanto/common/metadata.proto at 36:1
 */
export const ClientMetadata = $root.lookupType('squareup.esperanto.common.ClientMetadata');
fixType(ClientMetadata);
Builder.createAndAttachToType(ClientMetadata);
/**
 * TODO(rothlisberger): add a vendor_reader_type enum and field.
 * Details about a payment that uses a reader provisioned by a third party vendor.
 *
 * SOURCE VendorReaderInfo @ squareup/esperanto/common/metadata.proto at 112:3
 */
ClientMetadata.VendorReaderInfo = $root.lookupType('squareup.esperanto.common.ClientMetadata.VendorReaderInfo');
fixType(ClientMetadata.VendorReaderInfo);
Builder.createAndAttachToType(ClientMetadata.VendorReaderInfo);
/**
 * Metadata to fine-tune the settlement & reconciliation process.
 *
 * Jee: as of (2013-05), only Starbucks is utilizing this functionality.
 *
 * SOURCE SettlementMetadata @ squareup/esperanto/common/metadata.proto at 144:1
 */
export const SettlementMetadata = $root.lookupType('squareup.esperanto.common.SettlementMetadata');
fixType(SettlementMetadata);
Builder.createAndAttachToType(SettlementMetadata);
/**
 * Metadata related to an A/B testing experiment for a given payment.
 *
 * Wrapper around repeated Experiment to allow side channel use and potential future additions.
 *
 * SOURCE PerformedExperimentMetadata @ squareup/esperanto/common/metadata.proto at 168:1
 */
export const PerformedExperimentMetadata = $root.lookupType('squareup.esperanto.common.PerformedExperimentMetadata');
fixType(PerformedExperimentMetadata);
Builder.createAndAttachToType(PerformedExperimentMetadata);
/**
 * Info on single experiment performed on this payment.
 *
 * SOURCE PerformedExperiment @ squareup/esperanto/common/metadata.proto at 172:3
 */
PerformedExperimentMetadata.PerformedExperiment = $root.lookupType('squareup.esperanto.common.PerformedExperimentMetadata.PerformedExperiment');
fixType(PerformedExperimentMetadata.PerformedExperiment, {
  name: {
    notEmpty: true
  },
  bucketName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PerformedExperimentMetadata.PerformedExperiment);
/**
 * Contains additional payment and settlement metadata that is not specific
 * to the tender type of the payment.
 *
 * SOURCE PaymentMetadata @ squareup/esperanto/common/metadata.proto at 202:1
 */
export const PaymentMetadata = $root.lookupType('squareup.esperanto.common.PaymentMetadata');
fixType(PaymentMetadata);
Builder.createAndAttachToType(PaymentMetadata);
/**
 * Represents capabilities that may be allowed for a payment.
 *
 * SOURCE PaymentCapability @ squareup/esperanto/common/metadata.proto at 413:3
 */
PaymentMetadata.PaymentCapability = $root.lookupEnum('squareup.esperanto.common.PaymentMetadata.PaymentCapability').values;
/**
 * Storage for updates to the payment. The payment can be updated while in an approved state and
 * the final data should be specified when the payment is completed.
 *
 * SOURCE UpdatedPaymentData @ squareup/esperanto/common/metadata.proto at 537:1
 */
export const UpdatedPaymentData = $root.lookupType('squareup.esperanto.common.UpdatedPaymentData');
fixType(UpdatedPaymentData);
Builder.createAndAttachToType(UpdatedPaymentData);
/**
 * Details specific to CASH type payments.
 *
 * SOURCE CashPaymentDetails @ squareup/esperanto/common/metadata.proto at 571:1
 */
export const CashPaymentDetails = $root.lookupType('squareup.esperanto.common.CashPaymentDetails');
fixType(CashPaymentDetails);
Builder.createAndAttachToType(CashPaymentDetails);
/**
 * Payment-level processing fee data.
 *
 * SOURCE ProcessingFeeEvent @ squareup/esperanto/common/metadata.proto at 582:1
 */
export const ProcessingFeeEvent = $root.lookupType('squareup.esperanto.common.ProcessingFeeEvent');
fixType(ProcessingFeeEvent);
Builder.createAndAttachToType(ProcessingFeeEvent);
/**
 * The type of payment event this fee is associated with.
 *
 * SOURCE Type @ squareup/esperanto/common/metadata.proto at 602:3
 */
ProcessingFeeEvent.Type = $root.lookupEnum('squareup.esperanto.common.ProcessingFeeEvent.Type').values;
/**
 * The type of the fee, based on its recipient.
 *
 * SOURCE FeeType @ squareup/esperanto/common/metadata.proto at 634:3
 */
ProcessingFeeEvent.FeeType = $root.lookupEnum('squareup.esperanto.common.ProcessingFeeEvent.FeeType').values;
/**
 * Represents information about feeplans data - on how the processing fee was captured & applied.
 * Note: this is intended to be the "home" of feeplans data, going forward.
 *
 * SOURCE PricingMetadata @ squareup/esperanto/common/metadata.proto at 656:1
 */
export const PricingMetadata = $root.lookupType('squareup.esperanto.common.PricingMetadata');
fixType(PricingMetadata);
Builder.createAndAttachToType(PricingMetadata);
/**
 * This corresponds to the feeplan type stored in Feeplans
 *
 * SOURCE PricingType @ squareup/esperanto/common/metadata.proto at 660:3
 */
PricingMetadata.PricingType = $root.lookupEnum('squareup.esperanto.common.PricingMetadata.PricingType').values;
/**
 * Payment-level app processing fee data.
 *
 * SOURCE AppFeeEvent @ squareup/esperanto/common/metadata.proto at 690:1
 */
export const AppFeeEvent = $root.lookupType('squareup.esperanto.common.AppFeeEvent');
fixType(AppFeeEvent);
Builder.createAndAttachToType(AppFeeEvent);
/**
 * SOURCE Type @ squareup/esperanto/common/metadata.proto at 707:3
 */
AppFeeEvent.Type = $root.lookupEnum('squareup.esperanto.common.AppFeeEvent.Type').values;
/**
 * Used to denote the result of a risk review. Used for both asynchronous and synchronous risk
 * review refund flows.
 *
 * SOURCE RiskReviewResult @ squareup/esperanto/common/metadata.proto at 744:1
 */
export const RiskReviewResult = $root.lookupEnum('squareup.esperanto.common.RiskReviewResult').values;
/**
 * Details pertaining to the synchronous review of the refund request.
 *
 * SOURCE SynchronousRefundReviewDetails @ squareup/esperanto/common/metadata.proto at 757:1
 */
export const SynchronousRefundReviewDetails = $root.lookupType('squareup.esperanto.common.SynchronousRefundReviewDetails');
fixType(SynchronousRefundReviewDetails);
Builder.createAndAttachToType(SynchronousRefundReviewDetails);
/**
 * Details pertaining to the balance-based review portion of the synchronous refund review
 * process.
 *
 * SOURCE BalanceBasedRefundReviewDetails @ squareup/esperanto/common/metadata.proto at 763:3
 */
SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails = $root.lookupType('squareup.esperanto.common.SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails');
fixType(SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails);
Builder.createAndAttachToType(SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails);
/**
 * The configuration used to determine the threshold.
 *
 * SOURCE Configuration @ squareup/esperanto/common/metadata.proto at 766:5
 */
SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails.Configuration = $root.lookupEnum('squareup.esperanto.common.SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails.Configuration').values;
/**
 * The decision ultimately produced by the balance-based refund reviewer. May come from any of
 * several possible sources; see DecisionSource.
 *
 * SOURCE Decision @ squareup/esperanto/common/metadata.proto at 814:5
 */
SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails.Decision = $root.lookupEnum('squareup.esperanto.common.SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails.Decision').values;
/**
 * SOURCE DecisionSource @ squareup/esperanto/common/metadata.proto at 821:5
 */
SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails.DecisionSource = $root.lookupEnum('squareup.esperanto.common.SynchronousRefundReviewDetails.BalanceBasedRefundReviewDetails.DecisionSource').values;
/**
 * SOURCE RefundMetadata @ squareup/esperanto/common/metadata.proto at 878:1
 */
export const RefundMetadata = $root.lookupType('squareup.esperanto.common.RefundMetadata');
fixType(RefundMetadata);
Builder.createAndAttachToType(RefundMetadata);
/**
 * Contains details about the amount of money the app developer is contributing to each refund.
 * If a refund is not mentioned here, the amount is assumed to be zero.
 *
 * These app fees are factored out here, rather than embedded in the RefundReservationIntent,
 * because they will apply to more than just Card Transactions. For instance, Balance payments may
 * be refunded too.
 *
 * SOURCE RefundAppFee @ squareup/esperanto/common/metadata.proto at 985:1
 */
export const RefundAppFee = $root.lookupType('squareup.esperanto.common.RefundAppFee');
fixType(RefundAppFee);
Builder.createAndAttachToType(RefundAppFee);
/**
 * SOURCE OrderInfo @ squareup/esperanto/common/metadata.proto at 997:1
 */
export const OrderInfo = $root.lookupType('squareup.esperanto.common.OrderInfo');
fixType(OrderInfo);
Builder.createAndAttachToType(OrderInfo);
/**
 * Combination of all the metadata fields.
 *
 * SOURCE Metadata @ squareup/esperanto/common/metadata.proto at 1008:1
 */
export const Metadata = $root.lookupType('squareup.esperanto.common.Metadata');
fixType(Metadata);
Builder.createAndAttachToType(Metadata);
/**
 * Type of geolocation method used to determine the location of the payment.
 *
 * SOURCE GeoLocationType @ squareup/esperanto/common/metadata.proto at 1026:1
 */
export const GeoLocationType = $root.lookupEnum('squareup.esperanto.common.GeoLocationType').values;
/**
 * Contains details about the execution of the payment's delayed action. A delayed action is
 * executed when a payment has not reached a terminal state and it has passed the threshold of the
 * delayed_until_ms.
 *
 * SOURCE DelayedActionDetails @ squareup/esperanto/common/metadata.proto at 1037:1
 */
export const DelayedActionDetails = $root.lookupType('squareup.esperanto.common.DelayedActionDetails');
fixType(DelayedActionDetails);
Builder.createAndAttachToType(DelayedActionDetails);
/**
 * Represents an action to be performed after some configured delay.
 *
 * SOURCE DelayAction @ squareup/esperanto/common/metadata.proto at 1041:3
 */
DelayedActionDetails.DelayAction = $root.lookupEnum('squareup.esperanto.common.DelayedActionDetails.DelayAction').values;
/**
 * Metadata related to Square Card Pay-ins.
 *
 * SOURCE PayInMetadata @ squareup/esperanto/common/metadata.proto at 1064:1
 */
export const PayInMetadata = $root.lookupType('squareup.esperanto.common.PayInMetadata');
fixType(PayInMetadata);
Builder.createAndAttachToType(PayInMetadata);
/**
 * Metadata related to a Bill Pay Pull Payment. Populated for payments that are taken from a
 * merchant to fund an outgoing bill pay payment, e.g. to a 3rd party vendor.
 *
 * SOURCE BillPayPullMetadata @ squareup/esperanto/common/metadata.proto at 1086:1
 */
export const BillPayPullMetadata = $root.lookupType('squareup.esperanto.common.BillPayPullMetadata');
fixType(BillPayPullMetadata);
Builder.createAndAttachToType(BillPayPullMetadata);
/**
 * Metadata related to a SuperPOS Payment/Refund that is initiated with SuperPOS app.
 *
 * SOURCE SuperPosMetadata @ squareup/esperanto/common/metadata.proto at 1098:1
 */
export const SuperPosMetadata = $root.lookupType('squareup.esperanto.common.SuperPosMetadata');
fixType(SuperPosMetadata);
Builder.createAndAttachToType(SuperPosMetadata);
/**
 * Metadata related to a card surcharge, i.e. an extra amount levied by the merchant for using
 * a card instead of cash or another payment type.  This is not populated in some legacy payments
 * that have surcharges; for those information about the surcharge is only in
 * card_transaction.auth_intent.card_surcharge_amount.
 *
 * SOURCE CardSurchargeMetadata @ squareup/esperanto/common/metadata.proto at 1110:1
 */
export const CardSurchargeMetadata = $root.lookupType('squareup.esperanto.common.CardSurchargeMetadata');
fixType(CardSurchargeMetadata);
Builder.createAndAttachToType(CardSurchargeMetadata);
/**
 * Buyer's contact information.
 *
 * SOURCE BuyerInfo @ squareup/esperanto/common/metadata.proto at 1119:1
 */
export const BuyerInfo = $root.lookupType('squareup.esperanto.common.BuyerInfo');
fixType(BuyerInfo);
Builder.createAndAttachToType(BuyerInfo);
/**
 * Represents the source of buyer info data for an associated field.
 * Deprecated because this information is now stored in ConnectDetails.CustomerDetailSources.
 *
 * SOURCE DataSource @ squareup/esperanto/common/metadata.proto at 1124:3
 */
BuyerInfo.DataSource = $root.lookupEnum('squareup.esperanto.common.BuyerInfo.DataSource').values;
/**
 * Contains the policy for applying refunds to this payment.
 *
 * SOURCE RefundPolicy @ squareup/esperanto/common/metadata.proto at 1189:1
 */
export const RefundPolicy = $root.lookupType('squareup.esperanto.common.RefundPolicy');
fixType(RefundPolicy);
Builder.createAndAttachToType(RefundPolicy);
/**
 * Represents a refund splitting strategy amongst parties involved in a payment.
 *
 * SOURCE RefundSplitStrategy @ squareup/esperanto/common/metadata.proto at 1191:3
 */
RefundPolicy.RefundSplitStrategy = $root.lookupEnum('squareup.esperanto.common.RefundPolicy.RefundSplitStrategy').values;
/**
 * Contains details about a converted monetary amount using an exchange rate determined
 * at a specific time.
 *
 * SOURCE ForeignExchange @ squareup/esperanto/common/metadata.proto at 1217:1
 */
export const ForeignExchange = $root.lookupType('squareup.esperanto.common.ForeignExchange');
fixType(ForeignExchange);
Builder.createAndAttachToType(ForeignExchange);
/**
 * Represents currency exchange information for payments where the buyer's currency
 * differs from the merchant's currency.
 *
 * SOURCE CurrencyExchange @ squareup/esperanto/common/metadata.proto at 1254:1
 */
export const CurrencyExchange = $root.lookupType('squareup.esperanto.common.CurrencyExchange');
fixType(CurrencyExchange);
Builder.createAndAttachToType(CurrencyExchange);
/**
 * Exchange provider details.
 *
 * SOURCE ExchangeProvider @ squareup/esperanto/common/metadata.proto at 1269:1
 */
export const ExchangeProvider = $root.lookupType('squareup.esperanto.common.ExchangeProvider');
fixType(ExchangeProvider);
Builder.createAndAttachToType(ExchangeProvider);
/**
 * Type of exchange provider.
 *
 * SOURCE Type @ squareup/esperanto/common/metadata.proto at 1283:3
 */
ExchangeProvider.Type = $root.lookupEnum('squareup.esperanto.common.ExchangeProvider.Type').values;
/**
 * Contains metadata related to actions performed by an admin (one that has permissions to make
 * edits to a payment). It does not represent any meaningful update to the payment data.
 *
 * SOURCE InternalAdminMetadata @ squareup/esperanto/common/metadata.proto at 1303:1
 */
export const InternalAdminMetadata = $root.lookupType('squareup.esperanto.common.InternalAdminMetadata');
fixType(InternalAdminMetadata);
Builder.createAndAttachToType(InternalAdminMetadata);
/**
 * Information about the terminal device that took the payment (or the lack thereof).
 *
 * SOURCE TerminalData @ squareup/esperanto/common/metadata.proto at 1316:1
 */
export const TerminalData = $root.lookupType('squareup.esperanto.common.TerminalData');
fixType(TerminalData);
Builder.createAndAttachToType(TerminalData);
/**
 * Possible capabilities that a terminal could have.
 *
 * SOURCE TerminalCapability @ squareup/esperanto/common/metadata.proto at 1320:3
 */
TerminalData.TerminalCapability = $root.lookupEnum('squareup.esperanto.common.TerminalData.TerminalCapability').values;
/**
 * SOURCE TerminalConfiguration @ squareup/esperanto/common/metadata.proto at 1331:3
 */
TerminalData.TerminalConfiguration = $root.lookupType('squareup.esperanto.common.TerminalData.TerminalConfiguration');
fixType(TerminalData.TerminalConfiguration);
Builder.createAndAttachToType(TerminalData.TerminalConfiguration);
/**
 * SOURCE TerminalType @ squareup/esperanto/common/metadata.proto at 1332:5
 */
TerminalData.TerminalConfiguration.TerminalType = $root.lookupEnum('squareup.esperanto.common.TerminalData.TerminalConfiguration.TerminalType').values;
/**
 * SOURCE OfflinePaymentMetadata @ squareup/esperanto/common/metadata.proto at 1363:1
 */
export const OfflinePaymentMetadata = $root.lookupType('squareup.esperanto.common.OfflinePaymentMetadata');
fixType(OfflinePaymentMetadata);
Builder.createAndAttachToType(OfflinePaymentMetadata);